"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueuePushResult = void 0;
/**
 * Result for a push operation on a queue.
 */
class QueuePushResult {
    /**
     * Initializes a new instance of the @see QueuePushResult class.
     * @param hasPoped A value indicating whether a pop was required to push the new item.
     * @param popedItem Item that was popped to push the new item.
     */
    constructor(hasPoped, popedItem) {
        this.hasPoped = hasPoped;
        this.popedItem = popedItem;
    }
}
exports.QueuePushResult = QueuePushResult;
//# sourceMappingURL=queuePushResult.js.map